import createGuest from "cross-domain-storage/guest";

import config from "../config";

export const getUser = async () => {};

/**
 * pokusí se získat přihlášeného uživatele z hlavního webu
 * @param {Function} callback spustí se po získání odpovědi
 */
export function getUserFromMainSite(callback) {
  const storage = createGuest(config.MAIN_WEB_URL);
  storage.get("userData", (error, value) => {
    if (!callback(error, value)) {
      if (error) {
        storage.close();
      } else {
        storage.remove("userData", () => storage.close());
      }
    } else {
      storage.close();
    }
  });
}

/**
 * odhlásí uživatele z hlavního webu
 */
export function logOutUserFromMainSite(onResolve) {
  try {
    const storage = createGuest(config.MAIN_WEB_URL);
    storage.remove("userData", () => {
      storage.close();
      onResolve && onResolve();
    });
  } catch {
    onResolve && onResolve();
  }
}

/**
 * přihlásí uživatele na hlavním webu
 * @param {any} user objekt s uživatelem ze serveru
 */
export function loginUserToMainSite(user) {
  const storage = createGuest(config.MAIN_WEB_URL);
  storage.set("userData", JSON.stringify(user), () => storage.close());
}
